
















































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { CreateElement, RenderContext } from "vue";

@Component
export default class URowItem extends Vue {
  // Props

  @Prop({ default: false })
  public readonly hasSkeletons!: boolean;

  @Prop({ default: true })
  public readonly isClickable!: boolean;

  @Prop({ default: false })
  public readonly isLoading!: boolean;

  @Prop({ default: false })
  public readonly isSelectable!: boolean;

  @Prop({ default: true })
  public readonly isMultiselect!: boolean;

  @Prop({ default: false })
  public readonly isDisabled!: boolean;

  @Prop({ default: false })
  public readonly isDropdownDisabled!: boolean;

  @Prop({ default: false })
  public readonly isSelected!: boolean;

  @Prop({ default: false })
  public readonly isSortable!: boolean;

  @Prop({ default: false })
  public readonly isSortableDisabled!: boolean;

  @Prop({ default: false })
  public readonly isSelectedLinked!: boolean;

  @Prop({ default: true })
  public readonly showRightArrow!: boolean;

  // Methods

  public onSelect() {
    if (this.isDisabled || !this.isSelectable) return;
    return this.$emit("select", !this.isSelected);
  }

  public onClick(e: Event) {
    if (this.isDisabled || !this.isClickable) return;
    this.$emit("click", e);
    if (!this.isSelectedLinked) {
      this.onSelect();
    }
  }

  // Computed

  public get hasRouterLink() {
    return !this.$_.isEmpty(this.$attrs.to);
  }

  public get component() {
    return {
      functional: true,
      render: (h: CreateElement, { children }: RenderContext) => {
        const classes = [
          "u-row-item",
          this.isClickable && "is-clickable",
          this.isSelected && "is-selected",
          this.hasSkeletons && !this.isLoading && "is-empty"
        ];

        if (this.hasRouterLink)
          return h(
            "router-link",
            {
              class: classes,
              props: this.$attrs,
              nativeOn: {
                ...this.$listeners,
                click: this.onClick
              }
            },
            children
          );
        else
          return h(
            "a",
            {
              class: classes,
              on: {
                ...this.$listeners,
                click: this.onClick
              }
            },
            children
          );
      }
    };
  }
}
